import { render, staticRenderFns } from "./StorageStats.vue?vue&type=template&id=7a2b8c51&scoped=true&"
import script from "./StorageStats.vue?vue&type=script&lang=js&"
export * from "./StorageStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b8c51",
  null
  
)

export default component.exports